import { MINDMAP_VIEW, NARRATIVE_VIEW, RELATIONSHIP_VIEW, TIMELINE_VIEW } from "../constants/identifiers";

const getShouldShowViewSettings = viewType =>
  viewType === TIMELINE_VIEW ||
  viewType === RELATIONSHIP_VIEW ||
  viewType === NARRATIVE_VIEW ||
  viewType === MINDMAP_VIEW;

export default {
  getShouldShowViewSettings
};
